import React, { useState, useEffect } from 'react';
import TextLoop from "react-text-loop";
import { trackEvent } from "../../services/analytics";
import {Navbar, Nav, Image, NavDropdown} from 'react-bootstrap'
import { useTranslation } from 'react-i18next';
import LandingPageNav from "../../components/navbars/landingPage";
import FooterLandingPage from "../../components/footers/landing";
import Section from "../../components/landingPage/sections";
import {Helmet} from "react-helmet";

const Shipment = (props) => {
    const { t, i18n } = useTranslation();
    const [ lang, setLang ] = useState('en');
    const [ loading, setLoading ] = useState(true);

    useEffect(()=> {
        const lang = props.match.params.lang || localStorage.getItem('language');
        setLang(lang);
        setLoading(false);
        i18n.changeLanguage(lang)
        localStorage.setItem('language', lang);
    },[]);

    const onClickSignIn = (name) => {
        trackEvent('Click',{
            action: "track",
            category: "Buttons",
            label: name,
            event: "Click"
        })
    };

    return (
        <div>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Shipping Platform</title>
                <meta name="description" content="Dashboard pengiriman untuk memudahkan Anda mengirim dan melacak barang Anda." />
                <link rel="canonical" href="https://biteship.com/shipping" />
            </Helmet>
            <LandingPageNav/>

            <section className="slice header-section"
            style={{zIndex:0}}>
                <div className="order-1 ml-auto text-center mt-5">
                    <div className="card-body pl-5 header-title">
                        <h1 className="font-weight-900 text-black lh-150">
                            Pengiriman mulai banyak? <br/>Saatnya pakai dashboard kami
                        </h1>
                        <p className="lead lh-180">
                            Mulai dari pengiriman dalam kota dan antar kota semua bisa dipesan dari <b>Biteship</b>
                        </p>
                        <a href="https://dashboard.biteship.com/signin" onClick={() => onClickSignIn('Sign In Shipment Platform Header')}>
                            <button className="btn btn-primary mt-2" >
                                Mulai Kirim Barang
                            </button>
                        </a>
                    </div>
                    <br/>
                    <div className="col">
                        <Image
                            id="img-order-form"
                            alt="biteship-order-form"
                            src="/images/dashboard/order-form-multi-info.png"
                        />
                    </div>

                </div>
                <br/>
                <br/>
            </section>

            <section className="slice">
                <div className=' container'>
                    <h2>
                        <strong>
                            Berbagai layanan kurir
                        </strong>
                        <p className='lead mt-2'>
                            Biteship menyediakan berbagai macam layanan kurir tergantung kebutuhan pengiriman Anda tanpa perlu pusing ke masing-masing layanan.
                        </p>
                    </h2>

                    <h2 className='text-tiffany-500 mt-4'>
                        <strong>
                            Pengiriman Instan
                        </strong>
                    </h2>
                    <div className='row align-items-center text-center'>
                        <div className='col-3 pr-4 pl-4'>
                            <img alt="Biteship Shipment" style={{height:84}} src="/images/landing/biteship-lalamove.png" className="img-fluid"/>
                        </div>
                        <div className='col-3 pr-4 pl-4'>
                            <img alt="Biteship Shipment" style={{height:84}} src="/images/landing/biteship-grab.png" className="img-fluid"/>
                        </div>
                        <div className='col-3 pr-4 pl-4'>
                            <img alt="Biteship Shipment" style={{height:84}} src="/images/landing/biteship-gosend.png" className="img-fluid"/>
                        </div>
                        <div className='col-3 pr-4 pl-4'>
                            <img alt="Biteship Shipment" style={{height:40}} src="/images/landing/deliveree.png" className="img-fluid"/>
                        </div>
                    </div>

                    <div className='row align-items-center text-center mt-4'>
                        <div className='col-3 pr-4 pl-4'>
                            <img alt="Biteship Shipment" style={{height:30}} src="/images/landing/paxel.png" className="img-fluid"/>
                        </div>
                        <div className='col-3 pr-4 pl-4'>
                            <img alt="Biteship Shipment" style={{height:40}} src="/images/landing/biteship-rara.png" className="img-fluid"/>
                        </div>
                        <div className='col-3 pr-4 pl-4'>
                            <img alt="Biteship Shipment" style={{height:30}} src="/images/landing/borzo.png" className="img-fluid"/>
                        </div>
                        <div className='col-3 pr-4 pl-4'>
                            
                        </div>
                    </div>
                    <p className='lead text-violet-500 mt-4'><b>Banyak pilihan kurir instan lainnya</b></p>

                    <h2 className='text-tiffany-500 mt-6'>
                        <strong>
                            Pengiriman Reguler
                        </strong>
                    </h2>

                    <div className='row align-items-center text-center mt-4'>
                        <div className='col-3 pr-4 pl-4'>
                            <img alt="Biteship Shipment" style={{height:30}} src="/images/landing/jnt.png" className="img-fluid"/>
                        </div>
                        <div className='col-3 pr-4 pl-4'>
                            <img alt="Biteship Shipment" style={{height:40}} src="/images/landing/ninja.png" className="img-fluid"/>
                        </div>
                        <div className='col-3 pr-4 pl-4'>
                            <img alt="Biteship Shipment" style={{height:40}} src="/images/landing/jne.png" className="img-fluid"/>
                        </div>
                        <div className='col-3 pr-4 pl-4'>
                            <img alt="Biteship Shipment" style={{height:40}} src="/images/landing/rpx.png" className="img-fluid"/>
                        </div>
                    </div>

                    <div className='row align-items-center text-center mt-4'>
                        <div className='col-3 pr-4 pl-4'>
                            <img alt="Biteship Shipment" style={{height:40}} src="/images/landing/anteraja.png" className="img-fluid"/>
                        </div>
                        <div className='col-3 pr-4 pl-4'>
                            <img alt="Biteship Shipment" style={{height:50}} src="/images/landing/sap.png" className="img-fluid"/>
                        </div>
                        <div className='col-3 pr-4 pl-4'>
                            <img alt="Biteship Shipment" style={{height:50}} src="/images/landing/lion.png" className="img-fluid"/>
                        </div>
                        <div className='col-3 pr-4 pl-4'>
                            <img alt="Biteship Shipment" style={{height:50}} src="/images/landing/pos.png" className="img-fluid"/>
                        </div>
                    </div>

                    <div className='row align-items-center text-center mt-4'>
                        <div className='col-3 pr-4 pl-4'>
                            <img alt="Biteship Shipment" style={{height:35}} src="/images/landing/tiki.png" className="img-fluid"/>
                        </div>
                        <div className='col-3 pr-4 pl-4'>
                            <img alt="Biteship Shipment" style={{height:30}} src="/images/landing/biteship-idx.png" className="img-fluid"/>
                        </div>
                        <div className='col-3 pr-4 pl-4'>
                            <img alt="Biteship Shipment" style={{height:70}} src="/images/landing/biteship-jdl.png" className="img-fluid"/>
                        </div>
                        <div className='col-3 pr-4 pl-4'>
                            <img alt="Biteship Shipment" style={{height:40}} src="/images/landing/sicepat.png" className="img-fluid"/>
                        </div>
                    </div>

                    <div className='row align-items-center text-center mt-4'>
                        <div className='col-3 pr-4 pl-4'>
                            <img alt="Biteship Shipment" style={{height:40}} src="/images/landing/wahana.png" className="img-fluid"/>
                        </div>
                        <div className='col-3 pr-4 pl-4'>
                            <img alt="Biteship Shipment" style={{height:40}} src="/images/landing/biteship-indah.png" className="img-fluid"/>
                        </div>
                        <div className='col-3 pr-4 pl-4'>
                            <img alt="Biteship Shipment" style={{height:80}} src="/images/landing/biteship-popexpress.png" className="img-fluid"/>
                        </div>
                        <div className='col-3 pr-4 pl-4'>
                            <img alt="Biteship Shipment" style={{height:80}} src="/images/landing/eslexpress.png" className="img-fluid"/>
                        </div>
                    </div>
                    <p className='lead text-violet-500 mt-4'><b>Banyak pilihan kurir reguler lainnya</b></p>


                    <h2 className='text-tiffany-500 mt-6'>
                        <strong>
                            Pengiriman Internasional
                        </strong>
                    </h2>

                    <div className='row align-items-center text-center mt-4'>
                        <div className='col-3 pr-4 pl-4'>
                            <img alt="Biteship Shipment" style={{height:30}} src="/images/landing/fedex.png" className="img-fluid"/>
                        </div>
                        <div className='col-3 pr-4 pl-4'>
                            <img alt="Biteship Shipment" style={{height:30}} src="/images/landing/biteship-tlx.png" className="img-fluid"/>
                        </div>
                        <div className='col-3 pr-4 pl-4'>
                            <img alt="Biteship Shipment" style={{height:30}} src="/images/landing/biteship-dhl.png" className="img-fluid"/>
                        </div>
                        <div className='col-3 pr-4 pl-4'>
                            <img alt="Biteship Shipment" style={{height:50}} src="/images/landing/biteship-janio.png" className="img-fluid"/>
                        </div>
                    </div>
                    <p className='lead text-violet-500 mt-4'><b>Banyak pilihan kurir reguler lainnya</b></p>

                </div>
               
            </section>

            <section className="slice bg-lighter ">
                <div className='container'>
                    <h2>
                        <strong>
                            Tingkatkan fleksibilitas pengiriman
                        </strong>
                        <p className='lead mt-2'>
                            Dengan menyediakan berbagai macam pilihan, customer Anda memiliki kebebasan dalam memilih layanan pengiriman sesuai kebutuhan customer.
                        </p>
                    </h2>
                    <div className='row mt-4'>
                        <div className='col-6'>
                            <img alt="Biteship Monitor Icon" style={{height:64}} src="/images/landing/biteship-monitor-icon.png" className="img-fluid"/>
                            <h2 className='text-tiffany-500 mt-2'>
                                <strong>
                                    Konversi penjualan meningkat
                                </strong>
                            </h2>
                            <p className='lead mt-2'>
                                Sebanyak <b>55%</b> dari customer tidak menjadi membeli barang karena harga pengiriman yang mahal
                            </p>
                        </div>
                        <div className='col-6'>
                            <img alt="Biteship Monitor Icon" style={{height:64}} src="/images/landing/biteship-puzzle-icon.png" className="img-fluid"/>
                            <h2 className='text-tiffany-500 mt-2'>
                                <strong>
                                    Bandingkan harga pengiriman
                                </strong>
                            </h2>
                            <p className='lead mt-2'>
                                Dengan banyak layanan kurir yang tersedia di Biteship, Anda dapat mebandingkan harga dan layanan sesuai kebutuhan Anda.
                            </p>
                        </div>
                    </div>
                </div>

            </section>

            <section className="slice shipment-feature-section mt-6">
                <div className="container">
                    <div style={{height:250}}/>
                    <h2 className="text-white lh-150 text-center">
                        <strong>
                            Nikmati Fitur Pendukung
                        </strong>
                    </h2>
                    <h5 className="text-swift-pink text-center">
                        Kirim barang tidak pernah semudah ini
                    </h5>
                </div>

                <div className="container my-6">
                    <div className="row  align-items-center">
                        <div className="col-lg-6">
                            <h2 className="text-white">
                                <strong>
                                    Tracking Pengiriman.
                                </strong>
                            </h2>
                            <p className="text-white lead my-4">Cek status pengiriman Anda secara real-time. Tidak perlu lagi cemas
                            keberadaan posisi barang Anda.</p>
                        </div>
                        <div className="col-lg-6">
                            <Image rounded alt="Biteship Real Time Tracker" src="/images/dashboard/tracking.png"
                                 className="img-fluid img-center"/>
                        </div>
                    </div>
                </div>

                <div className="container my-6">
                    <div className="row  align-items-center">
                        <div className="col-lg-6 order-2 order-lg-1">
                            <Image rounded alt="Biteship Add Address" src="/images/dashboard/add-address.png"
                                   className="img-fluid img-center"/>
                        </div>
                        <div className="col-lg-6 order-1 order-lg-2">
                            <h2 className="text-white">
                                <strong>
                                    Simpan Alamat.
                                </strong>
                            </h2>
                            <p className="text-white lead my-4">Sering melakukan pesanan ke tempat yang sama? Gunakan fitur simpan
                             alamat agar mempercepat proses penginputan pesanan.</p>
                        </div>

                    </div>
                </div>

                <div className="container my-6">
                    <div className="row  align-items-center">
                        <div className="col-lg-6">
                            <h2 className="text-white">
                                <strong>
                                    Prioritaskan Kurir Pilihan.
                                </strong>
                            </h2>
                            <p className="text-white lead my-4">Memiliki kurir favorit? Anda dapat prioritaskan kurir yang menurut
                            Anda penting untuk Anda.</p>
                        </div>
                        <div className="col-lg-6">
                            <Image rounded alt="Biteship Courier Option" src="/images/dashboard/courier-options.png"
                                   className="img-fluid img-center"/>
                        </div>
                    </div>
                </div>

                <div className="container my-6">
                    <h2 className="text-white lh-150 text-center">
                        <strong>
                            Lihat semua pengiriman Anda.
                        </strong>
                    </h2>
                    <h5 className="text-swift-pink text-center mb-5">
                        Pengiriman dari berbagai macam kurir dapat dipantau dalam satu layar
                    </h5>
                    <div>
                        <Image rounded alt="Biteship Home Orders" src="/images/dashboard/home-orders.png"
                               className="img-fluid img-center"/>
                    </div>
                </div>

                <div style={{height:220}}/>
            </section>

            <section className="slice bg-skew-white bg-transparent">
                    
                

            </section>

            <section className='slice bg-white mb-6'>
                <div className='container'>
                    <h2>
                        <strong>
                            Cara Menggunakan Biteship                        
                        </strong>
                        <p className='lead mt-2'>
                            Kami menawarkan <b className='text-violet-500'>4 cara</b> untuk menggunakan Biteship dalam proses pengiriman untuk Bisnis kamu
                        </p>
                    </h2>

                    <div className='row mt-4'>
                        <div className='col-6'>
                            <h2 className='text-tiffany-500 mt-2'>
                                <strong>
                                    via Mobile App
                                </strong>
                            </h2>
                            <p className='lead mt-2'>
                                Akses Biteship melalui aplikasi tersedia didownload untuk Android dan iOS.
                            </p>
                            <img alt="Biteship Monitor Icon" style={{height:192}} src="/images/landing/biteship-via-mobile-app.png" className="img-fluid"/>

                            <div className='lead mt-2'>
                                <a href='https://bit.ly/biteshipapp'>
                                    Download Mobile App Disini
                                </a>
                            </div>
                        </div>
                        <div className='col-6'>
                            <h2 className='text-tiffany-500 mt-2'>
                                <strong>
                                    via Dashboard Web App
                                </strong>
                            </h2>
                            <p className='lead mt-2'>
                                Akses Biteship dengan laptop atau PC Anda atau melalui browser favorit Anda. 
                            </p>
                            <img alt="Biteship Monitor Icon" style={{height:192}} src="/images/landing/biteship-via-web-app.png" className="img-fluid"/>
                            <div className='lead mt-2'>
                                <a href='https://dashboard.biteship.com/signin'>
                                    Menuju Dashboard Biteship
                                </a>
                            </div>
                        </div>
                    </div>

                    <div className='row mt-4'>
                        <div className='col-6'>
                            <h2 className='text-tiffany-500 mt-2'>
                                <strong>
                                    via Plugins Integration
                                </strong>
                            </h2>
                            <p className='lead mt-2'>
                                Menggunakan website builder seperti Shopify atau Wordpress? Gunakan plugins.
                            </p>
                            <img alt="Biteship Monitor Icon" style={{height:192}} src="/images/landing/biteship-via-plugin.png" className="img-fluid"/>
                            <div className='lead mt-2'>
                                <a href='/plugin'>
                                    Lihat Details Plugin
                                </a>
                            </div>
                        </div>
                        <div className='col-6'>
                            <h2 className='text-tiffany-500 mt-2'>
                                <strong>
                                    via API Integration
                                </strong>
                            </h2>
                            <p className='lead mt-2'>
                                Cocok untuk Anda yang membuat website atau platform sendiri dengan fleksibilitas yang tinggi.
                            </p>
                            <img alt="Biteship Monitor Icon" style={{height:192}} src="/images/landing/biteship-via-api.png" className="img-fluid"/>
                            <div className='lead mt-2'>
                                <a href='/docs/api'>
                                    Cek API Detail Disini
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{height:320}}/>
            </section>
            <Section/>
            <FooterLandingPage/>
        </div>
    )
}

export default Shipment;
